if (customElements.get('video-modal') === undefined) {
  const classes = {
    siteOverflowed: 'util-SiteOverflowed'
  }
  class VideoModal extends HTMLElement {
    constructor () {
      super()

      this.modalTriggerEls = document.querySelectorAll(
        '[data-el="video-modal.modal-trigger"]'
      )

      this.modalCloseEls = this.querySelectorAll(
        '[data-el="video-modal.modal-close"]'
      )

      this.modalVideoEl = this.querySelector(
        '[data-el="video-modal.modal-video"]'
      )

      this.modalIframeEl = this.querySelector(
        '[data-el="video-modal.modal-iframe"]'
      )

      this.setupVideoModal()
    }

    setupVideoModal () {
      if (!this.modalTriggerEls) return

      for (const modalTriggerEl of this.modalTriggerEls) {
        modalTriggerEl.addEventListener(
          'click',
          this.handleModalTrigger.bind(this)
        )
        // Add touch event listeners for mobile devices
        modalTriggerEl.addEventListener(
          'touchstart',
          this.handleModalTrigger.bind(this)
        )
      }

      for (const modalCloseEl of this.modalCloseEls) {
        modalCloseEl.addEventListener('click', this.handleModalClose.bind(this))
        // Add touch event listener for close buttons too
        modalCloseEl.addEventListener(
          'touchstart',
          this.handleModalClose.bind(this)
        )
      }
    }

    handleModalTrigger = e => {
      if (this.dataset.videoModalId === e.currentTarget.dataset.videoModalId) {
        // Handle Shopify/MP4 video
        if (this.modalVideoEl) {
          for (const source in this.modalVideoEl.children) {
            const videoSource = this.modalVideoEl.children[source]
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src
            }
          }

          this.modalVideoEl.load()
          this.modalVideoEl.classList.remove('lazy')
          this.modalVideoEl.play()
        }

        // Handle YouTube/Vimeo iframe
        if (this.modalIframeEl) {
          // Get the base URL from data-src
          let videoSrc = this.modalIframeEl.dataset.src

          // Add autoplay parameter
          if (videoSrc.includes('youtube.com')) {
            const separator = videoSrc.includes('?') ? '&' : '?'
            videoSrc += `${separator}autoplay=1`
          } else if (videoSrc.includes('vimeo.com')) {
            const separator = videoSrc.includes('?') ? '&' : '?'
            videoSrc += `${separator}autoplay=1`
          }

          // Set the src attribute only when modal opens
          this.modalIframeEl.src = videoSrc
          this.modalIframeEl.classList.remove('lazy')
        }

        this.setAttribute('aria-hidden', 'false')
        document.body.classList.add(classes.siteOverflowed)
        window.setTimeout(() => {
          this.classList.add('mod-Modal-ready')
        }, 500)
      }
    }

    handleModalClose = e => {
      if (!this.classList.contains('mod-Modal-ready')) return

      // Pause Shopify/MP4 video if it exists
      if (this.modalVideoEl) {
        this.modalVideoEl.pause()
      }

      // Stop YouTube/Vimeo video by removing the src
      if (this.modalIframeEl) {
        // Remove the src to stop the video and prevent it from loading in background
        this.modalIframeEl.src = ''
      }

      this.setAttribute('aria-hidden', 'true')
      document.body.classList.remove(classes.siteOverflowed)
      this.classList.remove('mod-Modal-ready')
    }
  }

  customElements.define('video-modal', VideoModal)
}
